module.exports = __webpack_public_path__ + "img/4.877c779b.jpg";